/**
 * @generated SignedSource<<d83cdbce9883f6120a830ca10ee02002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IdentityAccountTypes = "CANDIDATE" | "EMPLOYER" | "INTERNAL" | "%future added value";
export type IdentityUserAddAccountTypeInput = {
  accountType: string;
  clientMutationId: string;
  identityUserId: string;
};
export type UseIdentityUserAddAccountTypeMutation$variables = {
  input: IdentityUserAddAccountTypeInput;
};
export type UseIdentityUserAddAccountTypeMutation$data = {
  readonly data: {
    readonly payload: {
      readonly node: {
        readonly __id: string;
        readonly accountTypes: ReadonlyArray<IdentityAccountTypes>;
        readonly code: number;
        readonly createdAt: string;
        readonly email: string;
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly identityUserId: string;
        readonly lastLoggedIn: string | null | undefined;
        readonly lastName: string | null | undefined;
        readonly updatedAt: string;
      };
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code?: string;
      readonly message?: string;
    }> | null | undefined;
  };
};
export type UseIdentityUserAddAccountTypeMutation = {
  response: UseIdentityUserAddAccountTypeMutation$data;
  variables: UseIdentityUserAddAccountTypeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "EdgeOfElevateIdentityUser",
  "kind": "LinkedField",
  "name": "payload",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityUser",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identityUserId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastLoggedIn",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountTypes",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ElevateUserError",
  "abstractKey": "__isElevateUserError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UseIdentityUserAddAccountTypeMutation",
    "selections": [
      {
        "alias": "data",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUserAddAccountTypePayload",
        "kind": "LinkedField",
        "name": "identityUserAddAccountType",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UseIdentityUserAddAccountTypeMutation",
    "selections": [
      {
        "alias": "data",
        "args": (v1/*: any*/),
        "concreteType": "IdentityUserAddAccountTypePayload",
        "kind": "LinkedField",
        "name": "identityUserAddAccountType",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userErrors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0c1139e0ebaa636fb574a87e75d2911d",
    "id": null,
    "metadata": {},
    "name": "UseIdentityUserAddAccountTypeMutation",
    "operationKind": "mutation",
    "text": "mutation UseIdentityUserAddAccountTypeMutation(\n  $input: IdentityUserAddAccountTypeInput!\n) {\n  data: identityUserAddAccountType(input: $input) {\n    payload {\n      node {\n        id\n        code\n        identityUserId\n        lastLoggedIn\n        firstName\n        lastName\n        email\n        updatedAt\n        createdAt\n        accountTypes\n      }\n    }\n    userErrors {\n      __typename\n      ... on ElevateUserError {\n        __isElevateUserError: __typename\n        code\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7e013662767e8a3efb5e763b24ad6dea";

export default node;
